export const unidades = [
  { id: 1, nome: 'Cajazeiras' },
  { id: 2, nome: 'Camaçari' },
  { id: 3, nome: 'Candeias' },
  { id: 3, nome: 'Cruz das Almas' },
  { id: 4, nome: 'Feira de Santana' },
  { id: 5, nome: 'Lauro de Freitas' },
  { id: 6, nome: 'Nazaré' },
  { id: 7, nome: 'Vitória da Conquista' },
  { id: 8, nome: 'São Sebastião do Passé'},
  { id: 9, nome: 'Jequié'}
];
